import App from '@/models/App'
export default {
    install(Vue) {
        const windowResizeListener = () => {
            App.update({
                where: 1,
                data: {
                    width: window.innerWidth,
                    height: window.innerHeight,
                },
            })
        }
        window.addEventListener('resize', windowResizeListener)
    },
}
